import api from '@/api/dy/groupChat.js'
const state = {
}
const mutations = {
}
const actions = {
	dyGroupIndex({}, params = {}) {
        return api.dyGroupIndex(params)
    },
    dyGroupAdd({}, params = {}) {
        return api.dyGroupAdd(params)
    },
    dyEditStatus({}, params = {}) {
        return api.dyEditStatus(params)
    },
    groupCourseList({}, params = {}) {
        return api.groupCourseList(params)
    },
    groupEdit({}, params = {}) {
        return api.groupEdit(params)
    },
    groupScope({}, params = {}) {
        return api.groupScope(params)
    },
	groupStatus({}, params = {}) {
        return api.groupStatus(params)
    },
	groupAuthInfo({}, params = {}) {
	    return api.groupAuthInfo(params)
	},
	groupUnbind({}, params = {}) {
	    return api.groupUnbind(params)
	}, 
    auditList({}, params = {}) {
        return api.auditList(params)
    },
    auditEdit({}, params = {}){
        return api.auditEdit(params)
    },
    groupDel({},params) {
		return api.groupDel(params)
	}

}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}
